module.exports = __webpack_public_path__ + "static/media/pool_betting_games.191639c5.svg";